import { makeAutoObservable } from 'mobx'
import { AlmanacFile } from 'types'

/**
 * Store to manage the TemplatePicker in the editor and template modals.
 */
class TemplatesStore {
  /**
   * The selected template being selected.
   */
  selectedModalTemplate: string | null = null

  /**
   * The selected template selected in the editor.
   */
  selectedPickerTemplate: string | null = null

  /**
   * Flag to show the template modal.
   */
  isTemplateModalOpen: boolean = false

  /**
   * Flag to show the template picker.
   */
  isPickerVisible: boolean = false

  /**
   * Flag to track if template modal is open from the picker
   */
  isTemplateModalOpenFromPicker: boolean = false

  /**
   * Method to show back button and method to call on click
   */
  onGoBack?: () => void

  /**
   * Folder to save template into
   */
  overrideFolder?: AlmanacFile | null = null

  /**
   * Workspace to save template into
   */
  overrideWorkspaceId?: number = undefined

  /**
   * Selected category
   */
  selectedCategory: string | null = null

  /**
   * Track Usage flag.
   * This flag tells if we need to track usage of the template inside useTemplateChangeListener
   */
  trackTemplateUsage: boolean = false

  constructor() {
    makeAutoObservable(this)
  }

  setState(state: Partial<TemplatesStore>) {
    Object.assign(this, state)
  }

  closeModal() {
    this.setState({
      isTemplateModalOpen: false,
      isTemplateModalOpenFromPicker: false,
      selectedModalTemplate: null,
      onGoBack: undefined,
      overrideFolder: null,
      overrideWorkspaceId: undefined,
    })
  }

  showModal() {
    this.setState({
      isTemplateModalOpen: true,
    })
  }

  closePicker() {
    this.setState({
      isPickerVisible: false,
      isTemplateModalOpenFromPicker: false,
      selectedModalTemplate: null,
      selectedPickerTemplate: null,
      onGoBack: undefined,
      overrideFolder: null,
      overrideWorkspaceId: undefined,
    })
  }
}

const templatesStore = new TemplatesStore()

export default templatesStore
